export default function IconDeliveryTruck({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <g clipPath="url(#clip0DeliveryTruck)">
        <path
          d="M24 4.32764V18.3726H20.8506C20.6158 19.3037 19.7538 19.9995 18.7549 19.9995C17.7336 19.9993 16.889 19.3037 16.6592 18.3735H6.68945C6.45436 19.3041 5.59317 19.9993 4.59473 19.9995C3.56352 19.9995 2.71142 19.2908 2.49121 18.3472V18.3726H0.078125V13.4116L3.25195 12.3716L4.85156 8.42432H9.70703V4.32764H24ZM4.59473 16.2661C3.74129 16.2661 3.02051 16.9859 3.02051 17.8394C3.02061 18.7192 3.71487 19.4126 4.59473 19.4126C5.47443 19.4124 6.16787 18.7191 6.16797 17.8394C6.16797 16.9595 5.47447 16.2663 4.59473 16.2661ZM18.7549 16.2661C17.9017 16.2664 17.1816 16.9861 17.1816 17.8394C17.1817 18.7191 17.8752 19.4123 18.7549 19.4126C19.6083 19.4126 20.329 18.7192 20.3291 17.8394C20.3291 16.9594 19.6348 16.2661 18.7549 16.2661ZM3.67871 12.8247L0.637695 13.8384V17.812H2.43652C2.46634 16.6629 3.43945 15.7319 4.59473 15.7319C5.77711 15.7321 6.72396 16.6641 6.75195 17.814H16.5977C16.6264 16.6642 17.5992 15.7322 18.7549 15.7319C19.9363 15.7319 20.8581 16.663 20.9121 17.812H23.4131V15.0122L9.72168 15.0112V9.01123H5.27832L3.67871 12.8247ZM10.3076 4.91553V8.42432H10.3086L10.3076 14.4253H23.4258V4.91553H10.3076Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0DeliveryTruck">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
